module.exports = __webpack_public_path__ + "img/Niger.78c1b51c.gif";